<template>
  <q-dialog persistent v-model="open" @hide="clearUrl">
    <q-card>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title> Visualização de NF</q-toolbar-title>
        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>
      <img :src="fileUrl" />
      <div v-if="pdfUrl" style="margin-top: 20px">
        <iframe :src="pdfUrl" width="545px" height="600px" style="border: none"></iframe>
      </div>

      <q-card-section class="justify-center row bg-red-5 text-white q-pa-none">
        <div v-if="file_status == 1" class="text-h6">NF já Aprovada</div>
        <div v-if="file_status == 2" class="text-h6">NF já Rejeitada</div>
      </q-card-section>
      <!-- align="right" -->
      <q-card-actions class="q-pa-md justify-between">
        <div>
          <q-btn
            no-caps
            unelevated
            label="Baixar NF"
            icon="mdi-download"
            color="primary"
            class="q-mr-md"
            @click="downloadFile"
          />
        </div>
        <div class="q-gutter-sm">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" />
          <q-btn
            :disabled="file_status != 0"
            color="positive"
            v-if="getProfiles.profile !== 'afiliado'"
            :label="'Aprovar'"
            @click="manageInvoiceUpload(file_id, 1)"
            no-caps
            unelevated
            type="submit"
            class="q-px-md"
          />

          <q-btn
            v-if="getProfiles.profile == 'afiliado' && file_status == 2"
            color="positive"
            label="Substituir NF"
            no-caps
            unelevated
            @click="$refs['fileInput'].pickFiles()"
            type="submit"
            class="q-px-md"
          />
          <q-file
            v-if="getProfiles.profile == 'afiliado' && file_status == 2"
            :ref="'fileInput'"
            class="hidden"
            accept=".pdf,.jpg,.jpeg,.png"
            @input="(file) => handleFileReUpload(file)"
          />
          <q-btn
            :disabled="file_status != 0"
            color="negative"
            v-if="getProfiles.profile !== 'afiliado'"
            :label="'Rejeitar'"
            @click="showDialogReject"
            no-caps
            unelevated
            type="submit"
            class="q-px-md"
          />
        </div>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import FileService from '@/services/FileService';
import FinanceService from '@/services/FinanceService';
import FinancialMixin from '../../../mixins/FinancialMixin';

export default {
  mixins: [FileService, FinanceService, FinancialMixin],
  props: {
    // model: {}
  },

  data() {
    return {
      fileUrl: '',
      pdfUrl: '',
      open: false,
      file_id: null,
      file_status: null,
      row: null
    };
  },
  computed: {
    getProfiles: {
      get() {
        return this.$store.state.Account.user;
      }
    }
  },

  methods: {
    downloadFile() {
      let link = document.createElement('a');
      link.setAttribute('download', `nota_fiscal_${this.file_id}`);

      if (this.fileUrl) {
        // imagem em base64
        link.setAttribute('href', this.fileUrl);
        link.setAttribute('download', `nota_fiscal_${this.file_id}.png`);
      } else if (this.pdfUrl) {
        // arquivo PDF Blob
        link.setAttribute('href', this.pdfUrl);
        link.setAttribute('download', `nota_fiscal_${this.file_id}.pdf`);
      } else {
        this.warningNotify('Arquivo não disponível para download.');
        return;
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    showDialogReject() {
      this.$q
        .dialog({
          title: 'Motivo<em>!</em>',
          //   message: `<span> Informe o motivo da rejeição dessa NF</span>`,
          prompt: {
            model: '',
            isValid: (val) => val.length > 2,
            type: 'text',
            attrs: {
              placeholder: 'Informe o motivo da rejeição dessa NF'
            }
          },
          cancel: { label: 'Cancelar', color: 'primary', outline: true },
          ok: { label: 'Enviar', color: 'positive' },
          persistent: true,
          html: true
        })
        .onOk((val) => {
          this.manageInvoiceUpload(this.file_id, 2, val);
        })
        .onCancel(() => {});
    },

    onClose() {
      this.open = false;
    },

    async manageInvoiceUpload(fileId, fileStatus, notes = '') {
      try {
        this.onLoading(true);
        const { status } = await this.invoiceUploadManage(fileId, fileStatus, notes ? notes : '');
        if (status === 200 && fileStatus === 1) this.successNotify('NF APROVADA com sucesso!');
        if (status === 200 && fileStatus === 2) this.successNotify('NF REJEITADA com sucesso!');
        this.getInvoicesPaymentsAffiliate();
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
        this.onClose();
      }
    },

    async getNfFileURL(row) {
      try {
        this.file_id = row.file_id;
        this.file_status = row.file_status;
        this.row = row;
        this.open = true;
        this.onLoading(true);
        const { data, headers } = await this.getFileContent(this.file_id);
        const content = headers['content-type'];

        if (content.includes('image')) {
          const base64 = this.arrayBufferToBase64(data);
          const imgSrc = 'data:image/png;base64,' + base64;
          this.fileUrl = imgSrc;
        } else {
          const blob = new Blob([data], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          // Guarda a URL no data para o iframe
          this.pdfUrl = url;
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    clearUrl() {
      this.fileUrl = '';
      this.pdfUrl = '';
      this.file_id = null;
      this.file_status = null;
    },

    async handleFileReUpload(file) {
      try {
        this.onLoading(true);
        const { status: statusDeletion } = await this.deleteInvoiceUpload(this.row.file_id);
        if (statusDeletion === 204) {
          const url = await this.uploadAffiliateNF(this.row.affiliate_id, this.row.oi_yearmonth, file);
          const { status } = await this.saveInvoiceUploadUrl(
            url,
            this.row.affiliate_id,
            this.row.invoice_payments_ids.split(','),
            this.row.oi_yearmonth
          );
          if (status == 201) {
            this.successNotify('Substituição realizada com sucesso');
            this.getAffiliateInvoicesPayments(null, `%26perPage=10%26affiliate_id=${this.getProfiles.affiliate_id}`);
            this.onClose();
          }
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>
